import { ViewFormComponentDataService } from './../view-form/shared/view-form-component-data.service';
import { CreationFormsFormService } from './shared/creation-forms-form.service';
import { CreationFormDataService } from './shared/creation-form-data.service';
import {
  Component,
  OnInit,
  HostListener,
  Output,
  EventEmitter,
  ViewChild,
  OnDestroy
} from '@angular/core';
import {
  Control,
  BaseControl,
  EspacioControl,
  TipoControl,
  ConfirmComponent,
  SubForma,
  TablaMaestra,
  InformacionTablaMaestra,
  ColumnaMaestra,
  CondicionControl,
  OperacionesControl,
  Forma,
  FiltrosSelectores,
  OptionsColumns,
  Static,
  Option,
  ColumnsTableModalSelect,
  AccesoMaestra,
  CondicionColumnaSelector,
  ValoresMaestraPorDefectoSeletor
} from '@app/shared';
import { DragulaService } from 'ng2-dragula';
import { TemplateRef, Input } from '@angular/core';
import { Logger } from '@app/core';
import {
  BsModalRef,
  BsModalService
} from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { find, filter } from 'lodash';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreationFormUtilsService } from './shared/creation-form.utils.sevice';
import { Subject } from 'rxjs';
import { LocalDataSource } from 'ng2-smart-table';
import { CreationDynamicComponentConfig } from '../shared/creation-dynamic-component-config.service';

const log: Logger = new Logger();

@Component({
  selector: 'iw-creation-form',
  templateUrl: './creation-form.component.html',
  styleUrls: ['./creation-form.component.scss'],
  providers: [
    CreationFormDataService,
    CreationFormsFormService,
    ViewFormComponentDataService,
    CreationFormUtilsService
  ]
})
export class CreationFormComponent implements OnInit, OnDestroy {
  // Identificador de el formulario
  @Input() idForm: number;
  // Orden del formulario dentro de la forma
  @Input() order: number;
  // Define si la accion a realiza es agregar o modificar
  @Input() addForm = true;
  // Formulario
  @Input() formI: SubForma;
  form: SubForma;
  // Identificador de el formulario
  @Input() formPrincipalI: Forma;
  formPrincipal: Forma;
  // Plantillas encargadas de renderizar el selector de pestañas
  @Input() selectTabTpl: TemplateRef<any>;
  // Pregunta para la modal
  question = '';
  // Define la accion de respuesta de la modal
  typeAccion = '';
  // Contiene el nombre de el tipo de control a editar
  controlEditSelect = '';
  // Nombre del formulario
  nameForm = '';
  // Alias del formulario
  aliasFormulario = '';
  // Forma seleccionado
  formSelect = '';
  // Formulario seleccionado
  formularioSelect = '';
  // tipo de fuente de datos
  typeSourceSelect = '';
  // tipo de selector seleccionado
  typeSelectorSelected = '';
  // Index del control seleccioonado en el formulario
  indexControlSelect = -1;
  //define si mostra el botón de documentos
  enableDocument: boolean = false;
  // orden maximo de los controles dentro del formulario
  orderControlMax = 1;
  // Contiene el id de la maestra dependencia seleccionada
  idMasterSelected = -1;
  // Numero de registros minimos en la tabla
  numberRows = 0;
  // Numero de registros maximos en la tabla
  numberRowsMax = 0;
  // Registros unicos
  onlyRows = false;
  // Define si el formulario que se esta creando o editando es una tabla
  typeTable = false;
  // Define cuando se abre el fomulario de creacion de controles
  openFormControl = false;
  // Define cuando se renderiza el formulario determinado para cada tipo de control
  openForm = false;
  // Define cuando el formulario se creara o editara
  editControlF = false;
  // activa el boton de guardar el formulario
  deActiveSave = true;
  // Define cuando mostrar el cargar de refrescar el select de maestras
  refresListMaster = false;
  // Define si el formulario es de autoguardado
  autoSave = false;
  // condiciones del selector de tipo Número
  comparisonCondictions: any[] = [];
  // Cntiene el tipo del nuevo control a agregar
  typeNewControl: TipoControl;
  // Contiene la maestra consultada
  master: InformacionTablaMaestra;
  // Tipos de control
  typesControl: Array<TipoControl> = [];
  // Contiene temporalmente las condiciones del control selecionado
  tmpFormulariosCondictions: Array<CondicionControl> = [];
  // Contiene temporalmente las operaciones del control selecionado
  tmpFormulariosOperations: Array<OperacionesControl> = [];
  // Contiene temporalmente los filtros del control selecionado
  tmpFormulariosFilters: Array<FiltrosSelectores> = [];
  // Contiene temporalmente las condiciones de las columnas
  tmpCondictionsColumns: Array<CondicionColumnaSelector>;
  // Contiene temporalmente las configuraciones de control de acceso a las maestras
  tmpMasterAccessControl: Array<AccesoMaestra> = [];
  // Contiene temporalmente las configuraciones de control de acceso a las maestras
  tmpRadicationsDocuments: number[] = [];
  // Contiene los trámites asociados
  tmpProcedures: any[] = [];
  // Contiene los filtros añadidos al selector de trámites
  tmpFilterProcedures: any[] = [];
  // contiene los id de los tipos documentales seleccionados
  typeDocumentaryList: any[] = []
  //define si al editar el selector de tipo documental, deba seguir buscando los asociados en la api
  searchDocumentary: boolean = false;
  // Contiene temporalmente los valores por defecto de la maestra configurados
  tmpDefaultValuesMaster: ValoresMaestraPorDefectoSeletor[] = [];
  // Lista de tamaños de los controles
  sizesControls: Array<EspacioControl> = [
    {
      espacio: 4,
      nombre: 'Pequeño'
    },
    {
      espacio: 6,
      nombre: 'Mediano'
    },
    {
      espacio: 12,
      nombre: 'Grande'
    }
  ];
  // Contiene el formulario nuevo
  newForm: SubForma;
  // Contiene el control seleccionado
  controlSelect: Control;
  // Contiene los controles del formulario
  controlsPalette: Array<Control> = [];
  // Contiene la informacion de las diferentes columnas de la maestra seleccionada
  columnsMaster: Array<OptionsColumns> = [];
  // Contiene la informacion de las diferentes columnas de la maestra seleccionada
  columnsMasterFilter: Array<OptionsColumns> = [];
  // clase base de los controles del formulario para agregar los campos
  controls: BaseControl<any>[] = [];
  // clase base de los controles del formulario dinamico para editar los campos
  controlsEdit: BaseControl<any>[] = [];
  // Referencia de la modal
  modalRef: BsModalRef;
  // Referencia de la modal opciones especiales de la tabla
  modalRefSpecialOptions: BsModalRef;
  // Referencia de la modal de los grupos de checkbox
  modalRefGrupoCheckbox: BsModalRef;
  // formulario que valiada el alias
  formAlias: FormGroup = new FormGroup({
    alias: new FormControl('', [Validators.pattern('^[a-zA-Z_]*$'), Validators.required])
  });
  // Contiene toodas las formas inplicadas en la forma actual e incluyendo esta
  allForms: Array<{ key: string, value: string }> = [];
  // Formularios de la forma seleccionada
  formularios: Array<{ key: string, value: string }> = [];
  // Campos del formulario seleccionada
  fields: Array<OptionsColumns> = [];
  // Campos del formulario seleccionada para los filtros
  fieldsFilter: Array<OptionsColumns> = [];
  // Contiene los formularios anteriormente cargados
  acumulateForm: any = {};
  // Contiene las opciones del formulario de los ngSelects para las tablas de formas
  options: any = {};
  //id del control seleccionado para editar
  control_id: number;
  // Templates de los selects de el formulario de creacion o edicion de selects
  templatesSelects = {};
  // define cuando mostrar la pestañna condiciones y operaciones
  conditionOperations = false;
  // Formulario modificable
  modifiable_form: boolean = false;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al template de la modal
  // modal de formulario de edicion de control
  @ViewChild('template') private template: TemplateRef<any>;
  // modal de formulario de creacion de control
  @ViewChild('templateFormCreate') private templateFormCreate: TemplateRef<any>;
  // modal de formulario de fuente de datos de la tabla
  @ViewChild('templateFountDataTable') private templateFountDataTable: TemplateRef<any>;
  // modal de las opciones especiales para tablas
  @ViewChild('templateSpecialOptions') private templateSpecialOptions: TemplateRef<any>;
  // modal de formulario de grupos de checkbox
  @ViewChild('templateGroupCheckbox') private templateGroupCheckbox: TemplateRef<any>;
  // referencia a la modal de documentos
  @ViewChild('templateSpecial') private templateSpecial: TemplateRef<any>;
  // modal de acciones
  @ViewChild('templateAccion') private templateAccion: TemplateRef<any>;
  // Referencia al componente de confirmación
  @ViewChild('confirmAction') private confirmAction: ConfirmComponent;
  // Referencia a la plantilla para el control personalizado de ng-select para las columnas de formularios o maestras
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  @ViewChild('ngSelectOnly') ngSelectTplOnly: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de ng-select para los formularios o maestras
  @ViewChild('ngSelectFormulario') ngSelectFormulario: TemplateRef<any>;
  // Referencia del select con refres para la lista de maestras
  @ViewChild('ngSelectRefresMaster') ngSelectRefresMaster: TemplateRef<any>;
  // Referencia del select con refres para la lista de consultas avanzadas
  @ViewChild('ngSelectRefresAdvanceSearch') ngSelectRefresAdvanceSearch: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de ng-select para la seleccion de grupos de checkbox
  @ViewChild('ngSelectGruposCheckbox') ngSelectGruposCheckbox: TemplateRef<any>;
  // salida del evento de cerrar
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  // salida del evento de guardar el formulario
  @Output() saveForm: EventEmitter<SubForma> = new EventEmitter();
  // salida del evento de guardar el formulario
  @Output() updateForm: EventEmitter<SubForma> = new EventEmitter();

  constructor(
    private dragulaService: DragulaService,
    private cdcds: CreationFormDataService,
    private cdcfs: CreationFormsFormService,
    private modalService: BsModalService,
    private toastr: ToastrService,
    private vfcds: ViewFormComponentDataService,
    private cfus: CreationFormUtilsService,
  ) {
    dragulaService.drop.subscribe((data: any) => {
      this.reorder();
    });
  }

  ngOnInit() {
    this.templatesSelects = {
      ngSelectTpl: this.ngSelectTpl,
      ngSelectTplOnly: this.ngSelectTplOnly,
      ngSelectFormulario: this.ngSelectFormulario,
      ngSelectGruposCheckbox: this.ngSelectGruposCheckbox,
      ngSelectRefresMaster: this.ngSelectRefresMaster,
      ngSelectRefresAdvanceSearch: this.ngSelectRefresAdvanceSearch
    };
    // Consulta tipos de controles
    this.cdcds.getTypesControl().subscribe(control => {
      this.typesControl = control;
    });
    // Consulta lista de maestras
    this.cdcds.getMasterTables().subscribe(mt => {
      this.masterTables = mt;
    });
    // Consulta lista de consultas personalizadas
    this.cdcds.getCustomSerach().subscribe(cs => {
      this.customSerach = cs;
    });
    this.formPrincipal = Static.copyObjet(this.formPrincipalI);
    if (this.addForm) {
      if (!this.formI) {
        this.newForm = {
          id_forma: this.idForm,
          orden: this.order,
          tabla: this.typeTable,
          nombre: this.nameForm,
          alias: this.aliasFormulario,
          estilo: {
            numero_registros_maximos: this.numberRowsMax,
            registro_unico: this.onlyRows
          },
          sub_formulario: null,
          condiciones: [],
          asociaciones: [],
          numero_registros: this.numberRows,
        };
      } else {
        this.newForm = Static.copyObjet(this.formI);
        this.nameForm = this.newForm.nombre;
        this.aliasFormulario = this.newForm.alias;
        this.formAlias.controls['alias'].setValue(this.newForm.alias);
        this.typeTable = this.newForm.tabla;
        this.cdcfs.table = this.typeTable;
        this.numberRows = this.newForm.numero_registros;
        this.numberRowsMax = this.newForm.estilo ?
          this.newForm.estilo['numero_registros_maximos'] ?
            this.newForm.estilo['numero_registros_maximos']
            : 0
          : 0;
        this.onlyRows = this.newForm.estilo ?
          this.newForm.estilo['registro_unico'] ?
            this.newForm.estilo['registro_unico']
            : 0
          : 0;
      }
    } else {
      this.form = Static.copyObjet(this.formI);
      this.modifiable_form = this.form.estilo['formulario_modificable'];
      if (!this.form.estilo['groupCheckbox']) {
        if (Object.keys(this.form.estilo).length) {
          this.form.estilo['groupCheckbox'] = [];
        } else {
          this.form.estilo = {
            groupCheckbox: [],
          };
        }
      }
      this.nameForm = this.form.nombre;
      this.aliasFormulario = this.form.alias;
      this.formAlias.controls['alias'].setValue(this.form.alias);
      if (this.form.estilo['auto_saved']) {
        this.autoSave = true;
      } else {
        this.autoSave = false;
      }
      this.controlsPalette = this.form.campos;
      this.typeTable = this.form.tabla;
      this.cdcfs.table = this.typeTable;
      this.orderControlMax = this.getIndexMaxForm();
      this.numberRows = this.form.numero_registros;
      this.numberRowsMax = this.form.estilo ?
        this.form.estilo['numero_registros_maximos'] ?
          this.form.estilo['numero_registros_maximos']
          : 0
        : 0;
      this.onlyRows = this.form.estilo ?
        this.form.estilo['registro_unico'] ?
          this.form.estilo['registro_unico']
          : 0
        : 0;
    }

    if (this.controlsPalette.length > 0) {
      this.deActiveSave = false;
    } else {
      this.deActiveSave = true;
    }
    if (this.formPrincipal.alias) {
      this.allForms.push({
        key: this.formPrincipal.alias,
        value: this.formPrincipal.alias
      });
    }
    if (this.formPrincipal.asociaciones && this.formPrincipal.asociaciones.length) {
      this.formPrincipal.asociaciones.forEach(association => {
        this.allForms.push({
          key: association.aliasAsociacion,
          value: association.aliasAsociacion
        });
      });
    }

    this.options = {
      forms: this.allForms
    };
    this.refreshGroupCheckbox();
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  trigger(callback: any, ...args: any[]) {
    return callback(...args);
  }

  set masterTables(mt: TablaMaestra[]) {
    this.cfus.masterTables = mt;
  }

  get masterTables(): TablaMaestra[] {
    return this.cfus.masterTables;
  }

  set customSerach(cs: any[]) {
    this.cfus.customSerach = cs;
  }

  get customSerach(): any[] {
    return this.cfus.customSerach;
  }

  /**
   * Controla los eventos al presionar las teclas
   *
   * @param {*} e
   * @memberof CreationFormComponent
   */
  @HostListener('window:keyup', ['$event'])
  onKeyUp(e: any) {
    switch (e.keyCode) {
      // Escape
      case 27:
        if (this.openFormControl) {
          this.openFormControl = false;
        } else if (this.editControlF) {
          this.editControlF = false;
        } else {
          this.action('close');
        }
        break;
    }
  }

  /**
   * Obtener si la tabla esta configurada de solo un registro
   *
   * @returns {boolean}
   * @memberof CreationFormComponent
   */
  getOnlyRow(): boolean {
    let only = false;
    if (this.typeTable && this.controlsPalette && this.controlsPalette.length) {
      const ctrl = find(this.controlsPalette, control => control.propiedades['columna_general']);
      if (ctrl) {
        only = true;
      }
    }
    return only;
  }

  /**
   * Guarda la informacion del control creado o seleccionado
   *
   * @param {*} data
   * @param {string} [action='agregar']
   * @memberof CreationFormComponent
   */
  async saveControl(data: any, action: string = 'agregar') {
    const controlValid = this.validControl(data, action);
    if (controlValid) {
      let newControl: Control;
      const shortid = require('shortid');
      let valid = true;
      switch (this.typeNewControl.nombre) {
        case 'text':
          if (data.txtMax) {
            if (Number(data.txtMax) < Number(data.txtMin)) {
              valid = false;
              this.toastr.warning('El mínimo de caracteres no puede ser mayor al máximo de caracteres.',
                'Información errónea');
              break;
            }
          }
          newControl = {
            nombre_campo: shortid.generate(),
            tipo_campo: this.typeNewControl,
            label: data.txtLabel,
            espacio: data.cboEspacios,
            requerido: data.chRequiered ? data.chRequiered : false,
            placeholder: data.txtPlaceholder,
            tooltip: data.txtTooltip,
            dato_radicacion: data.txtRadicacion, // Se pasa el dato de radicación
            orden: 0,
            validaciones: {
              condiciones: [],
              operaciones: []
            },
            propiedades: {
              max: data.txtMax,
              min: data.txtMin,
              expresion: data.txtExpresion,
              mensajeExpresion: data.txtErrorExp,
              bloquear: data.chBloquear,
              redonly: data.chReadOnly,
              mostrarTabla: this.typeTable ? data.chMostrarEnTabla : false,
              modificar_tabla: this.typeTable ? data.chModificarEnTabla : false,
              sin_filtro: this.typeTable ? data.chSinFiltro : false,
              transform: data.cboTransform,
              tamano_columna: data.txtTamanoColumna ? data.txtTamanoColumna : null,
              campo_interno: data.chInterno ? data.chInterno : false,
              unico: data.chUnico ? data.chUnico : false,
            },
            estilos: [],
            lista_maestra: [],
            alias: data.txtAlias,
            sincronizado: data.chSincronizar,
          };
          break;
        case 'number':
        case 'password':
          if (data.txtMax) {
            if (Number(data.txtMax) < Number(data.txtMin)) {
              valid = false;
              if (this.typeNewControl.nombre === 'number') {
                this.toastr.warning('El valor mínimo no puede ser mayor al valor máximo.',
                  'Información errónea');
              } else {
                this.toastr.warning('El mínimo de caracteres no puede ser mayor al máximo de caracteres.',
                  'Información errónea');
              }
              break;
            }
          }
          newControl = {
            nombre_campo: shortid.generate(),
            tipo_campo: this.typeNewControl,
            label: data.txtLabel,
            espacio: data.cboEspacios,
            requerido: data.chRequiered ? data.chRequiered : false,
            placeholder: data.txtPlaceholder,
            tooltip: data.txtTooltip,
            dato_radicacion: data.txtRadicacion, // Se pasa el dato de radicación
            orden: 0,
            validaciones: {
              condiciones: [],
              operaciones: []
            },
            propiedades: {
              max: data.txtMax,
              min: data.txtMin,
              expresion: data.txtExpresion,
              mensajeExpresion: data.txtErrorExp,
              bloquear: data.chBloquear,
              redonly: data.chReadOnly,
              mostrarTabla: this.typeTable ? data.chMostrarEnTabla : false,
              modificar_tabla: this.typeTable ? data.chModificarEnTabla : false,
              sin_filtro: this.typeTable ? data.chSinFiltro : false,
              tamano_columna: data.txtTamanoColumna ? data.txtTamanoColumna : null,
              campo_interno: data.chInterno ? data.chInterno : false,
              unico: data.chUnico ? data.chUnico : false,
              comparacion_valores: this.comparisonCondictions
            },
            estilos: [],
            lista_maestra: [],
            alias: data.txtAlias,
            sincronizado: data.chSincronizar,
          };
          if (this.typeNewControl.nombre === 'number') {
            newControl.propiedades['enteros'] = data.chEnteros;
            newControl.propiedades['mayorQue'] = data.chMayorQue;
            newControl.propiedades['menorQue'] = data.chMenorQue;
            newControl.propiedades['cantidadDecimales'] = data.txtCantidadDecimales;

            newControl.propiedades['roundFloorDecimal'] = data.chRoundFloorDecimal;
            newControl.propiedades['roundDecimal'] = data.chRoundDecimal;
            newControl.propiedades['roundCeilDecimal'] = data.chRoundCeilDecimal;

            newControl.propiedades['roundFloor'] = data.chRoundFloor;
            newControl.propiedades['round'] = data.chRound;
            newControl.propiedades['roundCeil'] = data.chRoundCeil;

            newControl.propiedades['separadorMiles'] = data.cboSeparadorMiles;
            newControl.propiedades['separadorDecimales'] = data.cboSeparadorDecimales;
          }
          break;
        case 'textarea':
          if (data.txtMax) {
            if (Number(data.txtMax) < Number(data.txtMin)) {
              valid = false;
              this.toastr.warning('El mínimo de caracteres no puede ser mayor al máximo de caracteres.',
                'Información errónea');
              break;
            }
          }
          newControl = {
            nombre_campo: shortid.generate(),
            tipo_campo: this.typeNewControl,
            label: data.txtLabel,
            espacio: data.cboEspacios,
            requerido: data.chRequiered ? data.chRequiered : false,
            placeholder: data.txtPlaceholder,
            tooltip: data.txtTooltip,
            dato_radicacion: data.txtRadicacion, // Se pasa el dato de radicación
            propiedades: {
              rows: data.txtRows,
              max: data.txtMax,
              min: data.txtMin,
              bloquear: data.chBloquear,
              redonly: data.chReadOnly,
              mostrarTabla: this.typeTable ? data.chMostrarEnTabla : false,
              modificar_tabla: this.typeTable ? data.chModificarEnTabla : false,
              sin_filtro: this.typeTable ? data.chSinFiltro : false,
              transform: data.cboTransform,
              tamano_columna: data.txtTamanoColumna ? data.txtTamanoColumna : null,
              campo_interno: data.chInterno ? data.chInterno : false,
              unico: data.chUnico ? data.chUnico : false,
              usar_editor: data.chUsarEditor ? data.chUsarEditor : false
            },
            orden: 0,
            validaciones: {
              condiciones: [],
              operaciones: []
            },
            estilos: [],
            lista_maestra: [],
            alias: data.txtAlias,
            sincronizado: data.chSincronizar,
          };
          break;
        case 'checkbox':
          newControl = {
            nombre_campo: shortid.generate(),
            tipo_campo: this.typeNewControl,
            label: data.txtLabel,
            espacio: data.numFilas,
            requerido: (data.cboTipoCheckbox === 'opcionMultiple') ?
              false :
              data.chRequiered ?
                data.chRequiered :
                false,
            placeholder: '',
            tooltip: data.txtTooltip,
            dato_radicacion: data.txtRadicacion, // Se pasa el dato de radicación
            orden: 0,
            validaciones: {
              condiciones: [],
              operaciones: []
            },
            propiedades: {
              bloquear: data.chBloquear,
              redonly: data.chReadOnly,
              mostrarTabla: this.typeTable ? data.chMostrarEnTabla : false,
              modificar_tabla: this.typeTable ? data.chModificarEnTabla : false,
              sin_filtro: this.typeTable ? data.chSinFiltro : false,
              tipoCheckbox: data.cboTipoCheckbox,
              grupoCheckbox: data.cboGruposCheckbox,
              default: data.cboDefault,
              tamano_columna: data.txtTamanoColumna ? data.txtTamanoColumna : null,
              campo_interno: data.chInterno ? data.chInterno : false,
              unico: data.chUnico ? data.chUnico : false
            },
            estilos: [],
            lista_maestra: [],
            alias: data.txtAlias,
            sincronizado: data.chSincronizar,
          };
          break;
        case 'email':
          newControl = {
            nombre_campo: shortid.generate(),
            tipo_campo: this.typeNewControl,
            label: data.txtLabel,
            espacio: data.cboEspacios,
            requerido: data.chRequiered ? data.chRequiered : false,
            placeholder: data.txtPlaceholder,
            tooltip: data.txtTooltip,
            dato_radicacion: data.txtRadicacion,// Se pasa el dato de radicación
            orden: 0,
            validaciones: {
              condiciones: [],
              operaciones: []
            },
            propiedades: {
              expresion: data.txtExpresion,
              mensajeExpresion: data.txtErrorExp,
              bloquear: data.chBloquear,
              redonly: data.chReadOnly,
              mostrarTabla: this.typeTable ? data.chMostrarEnTabla : false,
              modificar_tabla: this.typeTable ? data.chModificarEnTabla : false,
              sin_filtro: this.typeTable ? data.chSinFiltro : false,
              tamano_columna: data.txtTamanoColumna ? data.txtTamanoColumna : null,
              campo_interno: data.chInterno ? data.chInterno : false,
              unico: data.chUnico ? data.chUnico : false
            },
            estilos: [],
            lista_maestra: [],
            alias: data.txtAlias,
            sincronizado: data.chSincronizar,
          };
          break;
        case 'date-time-picker':
          let placeholder = 'DD/MM/YYYY';
          switch (data.cboTypePicker) {
            case 'timer':
              placeholder = 'HH:MM';
              break;
            case 'dateTimer':
              placeholder = 'DD/MM/YYYY HH:MM';
              break;
            case 'rangeDate':
              placeholder = 'DD/MM/YYYY - DD/MM/YYYY';
              break;
            case 'rangeTime':
              placeholder = 'HH:MM - HH:MM';
              break;
            case 'range':
              placeholder = 'DD/MM/YYYY HH:MM - DD/MM/YYYY HH:MM';
              break;
          }
          newControl = {
            nombre_campo: shortid.generate(),
            tipo_campo: this.typeNewControl,
            label: data.txtLabel,
            espacio: data.cboEspacios,
            requerido: data.chRequiered ? data.chRequiered : false,
            placeholder: placeholder,
            tooltip: data.txtTooltip,
            dato_radicacion: data.txtRadicacion, // Se pasa el dato de radicación
            orden: 0,
            validaciones: {
              condiciones: [],
              operaciones: []
            },
            propiedades: {
              tipo: data.cboTypePicker,
              fechaDesde: data.txtDesde,
              fechaActualDesde: data.chFechaActualDesde,
              fechaHasta: data.txtHasta,
              fechaActualHasta: data.chFechaActualHasta,
              bloquear: data.chBloquear,
              redonly: data.chReadOnly,
              mostrarTabla: this.typeTable ? data.chMostrarEnTabla : false,
              modificar_tabla: this.typeTable ? data.chModificarEnTabla : false,
              sin_filtro: this.typeTable ? data.chSinFiltro : false,
              tamano_columna: data.txtTamanoColumna ? data.txtTamanoColumna : null,
              campo_interno: data.chInterno ? data.chInterno : false,
              unico: data.chUnico ? data.chUnico : false
            },
            estilos: [],
            lista_maestra: [],
            alias: data.txtAlias,
            sincronizado: data.chSincronizar,
          };
          break;
        case 'ngSelect':
          let estructura: any[] = []
          if (data.cboTipoCarga == 'Tramites') {
            if (this.options['columns'] && this.options['columns'].length) {
              this.options['columns'].forEach((c: any) => {
                let valid = false
                data.cboColumn.forEach((d: any) => {
                  if (d == c.value) {
                    valid = true
                  }
                });
                if (valid) {
                  estructura.push(c['masterDependencia']);
                }
              });
            }
          }
          newControl = {
            nombre_campo: shortid.generate(),
            tipo_campo: this.typeNewControl,
            label: data.txtLabel ?
              data.txtLabel
              : (data.cboTipoCarga === 'Condicion') ?
                'condicion'
                : null,
            espacio: data.cboEspacios,
            requerido: data.chRequiered ? data.chRequiered : false,
            placeholder: data.txtPlaceholder,
            tooltip: data.txtTooltip,
            dato_radicacion: data.txtRadicacion, // Se pasa el dato de radicación
            orden: 0,
            tipos_documentales_selector: this.typeDocumentaryList,
            validaciones: {
              condiciones: [],
              operaciones: [],
              filtros: [],
              condiciones_columnas: this.tmpCondictionsColumns
            },
            propiedades: {
              columnas_seleccionadas: data.selectColumn,
              bloquear: data.chBloquear,
              tipo: data.cboTipoCarga,
              cargar_tabla: {
                form: data.cboForm,
                formulario: data.cboFormulario,
                column: data.cboColumn
              },
              condicion: data.txtAliasCondicion,
              mostrarTabla: this.typeTable ? data.chMostrarEnTabla : false,
              modificar_tabla: this.typeTable ? data.chModificarEnTabla : false,
              sin_filtro: this.typeTable ? data.chSinFiltro : false,
              redonly: data.chReadOnly,
              asociar_documentos: data.chAsociarDocumento ? data.chAsociarDocumento : false,
              asociar_expediente: data.chComoAsociar ? data.chComoAsociar : false,
              tipoSelector: data.cboTipoSelect,
              accionesInModal: {
                agregarInModal: data.chAgregar ? data.chAgregar : false,
                modificarInModal: data.chModificar ? data.chModificar : false,
                eliminarInModal: data.chEliminar ? data.chEliminar : false,
              },
              control_acceso_maestra: this.tmpMasterAccessControl,
              tipo_documento_radicado: this.tmpRadicationsDocuments,
              tramites: this.tmpProcedures,
              filtro_tramite: this.tmpFilterProcedures ? this.tmpFilterProcedures : null,
              estructura: estructura,
              validar_sede: data.chValidarSede ? data.chValidarSede : false,
              tamano_columna: data.txtTamanoColumna ? data.txtTamanoColumna : null,
              campo_interno: data.chInterno ? data.chInterno : false,
              columna_general: data.chCampoGeneral ? data.chCampoGeneral : false,
              unico: data.chUnico ? data.chUnico : false,
              consultaAvanzada: data.chConsultaAvanzada ? data.chConsultaAvanzada : false,
              consultaAvanzadaId: data.cboListaAvanzada ? data.cboListaAvanzada : null,
              campo_selector_dinamico: data.chDynamicSelector ? data.chDynamicSelector : false,
              selector_dinamico: data.cboDynamicSelector ? data.cboDynamicSelector : null,
              asociarProcedimientoFinaizar: data.chAsociarProcedimientoFinalizacion ? data.chAsociarProcedimientoFinalizacion : false
            },
            estilos: [],
            lista_maestra: [],
            alias: data.txtAlias,
            sincronizado: data.chSincronizar,
          };

          newControl.propiedades['auto_ajustar_tamano'] = data.chAutoAjustar ? data.chAutoAjustar : false;

          if (data.selectColumnValid) {
            newControl.propiedades['columna_validar_sede'] = data.selectColumnValid;
          }
          if (data.chGuardarMunicipio) {
            newControl.propiedades['guardar_municipio'] = data.selectColumnMunicipality;
          }

          if (data.cboTipoCarga === 'TablaMaestra') {
            let masterT: InformacionTablaMaestra;
            masterT = await this.cdcds.getInformacionMasterTable(Number(data.cboMasterTable));
            newControl.lista_maestra = [masterT];
            if (
              this.columnsMaster &&
              this.columnsMaster.length &&
              data.selectColumn &&
              data.selectColumn.length
            ) {
              const columnsModalSelector: Array<ColumnsTableModalSelect> = [];
              data.selectColumn.forEach((col: string) => {
                const selectColumn = find(this.columnsMaster, { value: col });
                if (selectColumn) {
                  let labelSelector = selectColumn.key.replace(':', '');
                  if (selectColumn.column !== selectColumn.key) {
                    labelSelector = selectColumn.key.replace(':', '');
                  }
                  const columSelector: ColumnsTableModalSelect = {
                    key: selectColumn.value,
                    label: labelSelector,
                    type: selectColumn.type,
                    category: selectColumn.category
                  };
                  columnsModalSelector.push(columSelector);
                }
              });
              newControl.propiedades['columnsSelectorModal'] = columnsModalSelector;
              newControl.propiedades['valores_defecto_maestra'] = this.tmpDefaultValuesMaster;
            }
          } else if (data.cboTipoCarga == 'Tramites') {
            if (data.cboColumn && data.cboColumn.length) {
              const columnsModalSelector: Array<ColumnsTableModalSelect> = [];
              let optionsColumns: OptionsColumns[] = []
              if (this.options['columns'] && this.options['columns'].length) {
                this.options['columns'].forEach((clmn: any) => {
                  let valid = false;
                  data.cboColumn.forEach((d: any) => {
                    if (d == clmn.value) {
                      valid = true
                    }
                  });
                  if (valid) {
                    optionsColumns.push(clmn);
                  }
                });
              }
              data.cboColumn.forEach((col: string) => {

                const selectColumn = find(optionsColumns, { value: col });
                if (selectColumn) {
                  let labelSelector = selectColumn['key'].replace(':', '');
                  if (selectColumn['column'] !== selectColumn['key']) {
                    labelSelector = selectColumn['column'].replace(':', '') + ' - ' + selectColumn['key'].replace(':', '');
                  }
                  const columSelector: ColumnsTableModalSelect = {
                    key: selectColumn.masterDependencia,
                    label: labelSelector,
                    type: selectColumn.type,
                    category: selectColumn.category
                  };
                  if (
                    selectColumn &&
                    selectColumn['columnsSelectorModal'] &&
                    selectColumn['columnsSelectorModal'].length
                  ) {
                    columSelector.columnsDependence = selectColumn['columnsSelectorModal'];
                  }
                  columnsModalSelector.push(columSelector);
                }
              });
              newControl.propiedades['columnsSelectorModal'] = columnsModalSelector;
            }
          } else if (data.cboTipoCarga == 'RadicadosSistema') {
            let columns: ColumnsTableModalSelect[] = []
            columns = [
              {
                key: "key",
                label: "Radicado",
                type: "text",
              },
              {
                key: "fecha_radicado",
                label: "Fecha radicado",
                type: "date-time-picker",
                category: "calendar",
              },
              {
                key: "tipo_documental",
                label: "Tipo",
                type: "text"
              },
            ];
            newControl.propiedades['columnsSelectorModal'] = columns;
          }
          else {
            if (
              this.fields &&
              this.fields.length &&
              data.cboColumn &&
              data.cboColumn.length
            ) {
              const columnsModalSelector: Array<ColumnsTableModalSelect> = [];
              data.cboColumn.forEach((col: string) => {
                const selectColumn = find(this.fields, { value: col });
                if (selectColumn) {
                  let labelSelector = selectColumn.key.replace(':', '');
                  if (selectColumn.column !== selectColumn.key) {
                    labelSelector = selectColumn.column.replace(':', '') + ' - ' + selectColumn.key.replace(':', '');
                  }
                  const columSelector: ColumnsTableModalSelect = {
                    key: selectColumn.value,
                    label: labelSelector,
                    type: selectColumn.type,
                    category: selectColumn.category
                  };
                  if (
                    selectColumn &&
                    selectColumn.columnsSelectorModal &&
                    selectColumn.columnsSelectorModal.length
                  ) {
                    columSelector.columnsDependence = selectColumn.columnsSelectorModal;
                  }
                  columnsModalSelector.push(columSelector);
                }
              });
              newControl.propiedades['columnsSelectorModal'] = columnsModalSelector;
            }
          }

          break;
        case 'label':
          newControl = {
            nombre_campo: shortid.generate(),
            tipo_campo: this.typeNewControl,
            label: data.txtLabel,
            espacio: data.cboEspacios,
            requerido: false,
            placeholder: '',
            dato_radicacion: data.txtRadicacion, // Se pasa el dato de radicación
            orden: 0,
            validaciones: {
              condiciones: [],
              operaciones: []
            },
            propiedades: {
              sizeFont: data.cboSize,
            },
            estilos: [],
            lista_maestra: [],
            alias: data.txtAlias,
            sincronizado: false,
          };

          break;
        case 'coordenadas':
          let nombreCampo = '';
          if (action === 'agregar') {
            nombreCampo = shortid.generate();
          } else {
            nombreCampo = this.controlsPalette[this.indexControlSelect].nombre_campo;
          }
          newControl = {
            nombre_campo: nombreCampo,
            tipo_campo: this.typeNewControl,
            label: data.txtLabel,
            espacio: 12,
            requerido: data.chRequiered,
            placeholder: '',
            dato_radicacion: data.txtRadicacion, // Se pasa el dato de radicación
            orden: 0,
            validaciones: {
              condiciones: [],
              operaciones: []
            },
            propiedades: {
              fieldName: {
                latitud: nombreCampo + '_latitud',
                longitud: nombreCampo + '_longitud',
                altura: nombreCampo + '_altura'
              },
              bloquear: data.chBloquear,
              redonly: data.chReadOnly,
              mostrarTabla: this.typeTable ? data.chMostrarEnTabla : false,
              modificar_tabla: this.typeTable ? data.chModificarEnTabla : false,
              sin_filtro: this.typeTable ? data.chSinFiltro : false,
              tamano_columna: data.txtTamanoColumna ? data.txtTamanoColumna : null,
              campo_interno: data.chInterno ? data.chInterno : false,
              unico: data.chUnico ? data.chUnico : false
            },
            estilos: [],
            lista_maestra: [],
            alias: data.txtAlias,
            sincronizado: data.chSincronizar,
          };

          break;
      }
      if (valid) {
        this.idMasterSelected = -1;
        newControl.propiedades['modificar_campo'] = data.chCampoModificable ? data.chCampoModificable : false;
        if (action === 'agregar') {
          newControl.orden = this.orderControlMax;
          newControl.validaciones.condiciones = this.tmpFormulariosCondictions;
          newControl.validaciones.operaciones = this.tmpFormulariosOperations;
          newControl.validaciones.filtros = this.tmpFormulariosFilters;
          this.controlsPalette.push(newControl);
          this.openFormControl = false;
          this.openForm = false;
          this.orderControlMax++;
        } else {
          newControl.orden = this.controlsPalette[this.indexControlSelect].orden;
          newControl.nombre_campo = this.controlsPalette[this.indexControlSelect].nombre_campo;
          newControl.validaciones.condiciones = this.tmpFormulariosCondictions;
          newControl.validaciones.operaciones = this.tmpFormulariosOperations;
          newControl.validaciones.filtros = this.tmpFormulariosFilters;
          this.controlsPalette[this.indexControlSelect] = newControl;
          this.indexControlSelect = -1;
          this.editControlF = false;
          this.controlEditSelect = '';
        }
        if (this.controlsPalette.length > 0) {
          this.deActiveSave = false;
        } else {
          this.deActiveSave = true;
        }
        this.tmpFormulariosCondictions = [];
        this.tmpFormulariosOperations = [];
        this.tmpFormulariosFilters = [];
        this.idMasterSelected = -1;
        this.typeSourceSelect = '';
        this.typeSelectorSelected = '';
        this.formularioSelect = '';
        this.formSelect = '';
        delete this.options['formularios'];
        delete this.options['colums'];
        delete this.options['columnsMasterFilter'];
        this.formularios = [];
        this.fields = [];
        this.columnsMaster = [];
        this.columnsMasterFilter = [];
        this.comparisonCondictions = [];
        this.modalRef.hide();
        this.options = {
          forms: this.allForms
        };
        this.refreshGroupCheckbox();
        this.formPrincipal.sub_formas.forEach(subForm => {
          if (subForm.alias === this.aliasFormulario) {
            subForm.campos = this.controlsPalette;
          }
        });
      }
    }
  }

  /**
   * Se encarga de cerrar la modal de el formulario de creacion o edicion de control
   *
   * @memberof CreationFormComponent
   */
  closeFormControl() {
    if (this.editControlF) {
      this.indexControlSelect = -1;
      this.idMasterSelected = -1;
      this.editControlF = false;
      delete this.controlEditSelect;
    } else {
      this.openFormControl = false;
    }
    this.openForm = false;
    this.formSelect = '';
    this.typeSourceSelect = '';
    this.options = {
      forms: this.allForms
    };
    this.refreshGroupCheckbox();
    this.modalRef.hide();
  }

  /**
   * Muestra el formulario del tipo de control seleccionado
   * tanto para el formulario de creacion o edicion
   *
   * @param {*} data
   * @memberof CreationFormComponent
   */
  async formControlSelect(data: TipoControl) {
    // log.debug(data);
    this.controlsEdit = [];
    this.controls = [];
    this.typeNewControl = data;
    if (this.typeNewControl) {
      await setTimeout(async () => {
        switch (this.typeNewControl.nombre) {
          case 'text':
          case 'password':
            if (this.editControlF) {
              this.controlsEdit = this.cdcfs.getFormText(this.sizesControls, this.controlSelect);
            } else {
              this.controls = this.cdcfs.getFormText(this.sizesControls);
            }
            this.openForm = true;
            break;
          case 'number':
            if (this.editControlF) {
              this.controlsEdit = this.cdcfs.getFormNumber(this.sizesControls, this.controlSelect);
            } else {
              this.controls = this.cdcfs.getFormNumber(this.sizesControls);
            }
            this.openForm = true;
            break;
          case 'textarea':
            if (this.editControlF) {
              this.controlsEdit = this.cdcfs.getFormTextArea(this.sizesControls, this.controlSelect);
            } else {
              this.controls = this.cdcfs.getFormTextArea(this.sizesControls);
            }
            this.openForm = true;
            break;
          case 'checkbox':
            if (this.editControlF) {
              this.controlsEdit = this.cdcfs.getFormCheck(this.templatesSelects, this.controlSelect);
            } else {
              this.controls = this.cdcfs.getFormCheck(this.templatesSelects);
            }
            this.openForm = true;
            break;
          case 'email':
            if (this.editControlF) {
              this.controlsEdit = this.cdcfs.getFormEmail(this.sizesControls, this.controlSelect);
            } else {
              this.controls = this.cdcfs.getFormEmail(this.sizesControls);
            }
            this.openForm = true;
            break;
          case 'date-time-picker':
            if (this.editControlF) {
              this.controlsEdit = this.cdcfs.getFormDate(this.sizesControls, this.controlSelect);
            } else {
              this.controls = this.cdcfs.getFormDate(this.sizesControls);
            }
            this.openForm = true;
            break;
          case 'ngSelect':
            if (this.editControlF) {
              this.controlSelect.propiedades["cargar_tabla"]["column"] = '';
              this.controlSelect.propiedades["cargar_tabla"]["formulario"] = null;
              this.controlSelect.propiedades["cargar_tabla"]["form"] = '';
              if (this.controlSelect.lista_maestra[0]) {
                if (this.idMasterSelected !== this.controlSelect.lista_maestra[0].id) {
                  this.idMasterSelected = this.controlSelect.lista_maestra[0].id;
                }
              }
              if (this.idMasterSelected > 0) {
                this.master = await this.cdcds.getInformacionMasterTable(this.idMasterSelected);
                this.columnsMaster = this.cfus.loadingColumnsViews(this.master.estructura, this.idMasterSelected);
                this.columnsMasterFilter = this.cfus.loadingColumnsViews(
                  this.master.estructura,
                  this.idMasterSelected,
                  true
                );
                this.options['columnsMasterFilter'] = filter(
                  this.cfus.loadingColumnsViews(
                    this.master.estructura,
                    this.idMasterSelected,
                    true,
                    false
                  ),
                  { type: 'ngSelect' }
                );
                if (this.options['columnsMasterFilter'] && this.options['columnsMasterFilter'].length) {
                  this.options['columnsMasterJurisdiccion'] = Static.copyObjet(this.options['columnsMasterFilter']);
                  if (this.options['columnsMasterJurisdiccion'] && this.options['columnsMasterJurisdiccion'].length) {
                    this.options['columnsMasterJurisdiccion'].push({
                      key: 'Id',
                      value: 'id',
                      masterDependencia: this.master.nombre,
                      column: 'Id',
                      type: 'number'
                    });
                  } else {
                    this.options['columnsMasterJurisdiccion'] = [];
                  }
                } else {
                  this.options['columnsMasterJurisdiccion'] = [];
                }
                this.controlsEdit = this.cdcfs.getFormSelect(
                  this.sizesControls,
                  this.masterTables,
                  this.customSerach,
                  this.templatesSelects,
                  this.controlSelect,
                  this.columnsMaster,
                  this.options
                );
              } else {
                this.controlsEdit = this.cdcfs.getFormSelect(
                  this.sizesControls,
                  this.masterTables,
                  this.customSerach,
                  this.templatesSelects,
                  this.controlSelect,
                  null,
                  this.options
                );

                this.options['dynamic_selectors'] = [];
                this.cdcds.getDynamicSelectorFields().subscribe(tsfs => {
                  if (tsfs.length > 0) {
                    tsfs.forEach(async tsf => {
                      await this.options['dynamic_selectors'].push({
                        key: tsf.id,
                        value: tsf.nombre
                      });
                    });
                    this.controls = this.cdcfs.getFormSelect(
                      this.sizesControls,
                      this.masterTables,
                      this.customSerach,
                      this.templatesSelects,
                      null,
                      null,
                      this.options
                    );
                  }
                });



                this.options['columns'] = [];

                this.cdcds.getTramitFields().subscribe(tsfs => {
                  if (tsfs.length > 0) {
                    tsfs.forEach(async tsf => {
                      await this.options['columns'].push({
                        column: tsf.nombre,
                        key: tsf.nombre,
                        masterDependencia: tsf.alias,
                        type: 'ngSelect',
                        value: tsf.id
                      });
                    });
                    this.controls = this.cdcfs.getFormSelect(
                      this.sizesControls,
                      this.masterTables,
                      this.customSerach,
                      this.templatesSelects,
                      null,
                      null,
                      this.options
                    );
                  }
                });
                /*this.options['columns'].push({column: 'Expediente', key: 'Número de expediente', masterDependencia: 'Ejemplo', type: 'ngSelect', value: 'expediente'}, 
                {column: 'Radicado', key: 'Fecha de radicado', masterDependencia: 'Ejemplo', type: 'ngSelect', value: 'fecha_radicado'},
                {column: 'Trámite', key: 'Nombre de trámite', masterDependencia: 'Ejemplo', type: 'ngSelect', value: 'no_tramite'})*/
                this.controls = this.cdcfs.getFormSelect(
                  this.sizesControls,
                  this.masterTables,
                  this.customSerach,
                  this.templatesSelects,
                  null,
                  null,
                  this.options
                );
              }
            } else {
              this.options['dynamic_selectors'] = [];
              this.cdcds.getDynamicSelectorFields().subscribe(tsfs => {
                if (tsfs.length > 0) {
                  tsfs.forEach(async tsf => {
                    await this.options['dynamic_selectors'].push({
                      key: tsf.id,
                      value: tsf.nombre
                    });
                  });
                  this.controls = this.cdcfs.getFormSelect(
                    this.sizesControls,
                    this.masterTables,
                    this.customSerach,
                    this.templatesSelects,
                    null,
                    null,
                    this.options
                  );
                }
              });

              this.options['columns'] = [];
              this.cdcds.getTramitFields().subscribe(tsfs => {
                if (tsfs.length > 0) {
                  tsfs.forEach(async tsf => {
                    await this.options['columns'].push({
                      column: tsf.nombre,
                      key: tsf.nombre,
                      masterDependencia: tsf.alias,
                      type: 'ngSelect',
                      value: tsf.id
                    });
                  });
                  this.controls = this.cdcfs.getFormSelect(
                    this.sizesControls,
                    this.masterTables,
                    this.customSerach,
                    this.templatesSelects,
                    null,
                    null,
                    this.options
                  );
                }
              });
              this.controls = this.cdcfs.getFormSelect(
                this.sizesControls,
                this.masterTables,
                this.customSerach,
                this.templatesSelects,
                null,
                null,
                this.options
              );
            }
            this.openForm = true;
            break;
          case 'label':
            if (this.editControlF) {
              this.controlsEdit = this.cdcfs.getFormLabel(this.sizesControls, this.controlSelect);
            } else {
              this.controls = this.cdcfs.getFormLabel(this.sizesControls);
            }
            this.openForm = true;
            break;
          case 'coordenadas':
            if (this.editControlF) {
              this.controlsEdit = this.cdcfs.getFormCoordinates(this.controlSelect);
            } else {
              this.controls = this.cdcfs.getFormCoordinates();
            }
            this.openForm = true;
            break;
        }
      });
    } else {
      this.openForm = false;
    }
  }

  /**
   * Carga la informacion de las columnas de la tabla dinamica seleccionada para mostrar en el ngSelect
   *
   * @param {Control[]} columns
   * @param {string} nameFont
   * @returns {Array<OptionsColumns>}
   * @memberof CreationFormComponent
   */
  loadingColumnsTablaForma(columns: Control[], nameFont: string, detail: boolean = true): Array<OptionsColumns> {
    const mastersC: Array<OptionsColumns> = [];
    columns.forEach(column => {
      if (column.alias) {
        if (column.tipo_campo.nombre === 'ngSelect' && detail) {
          // col.columnsSelectorModal = column.propiedades['columnsSelectorModal'];
          const columDependence = this.loadColumnsDependence(
            column.propiedades['columnsSelectorModal'],
            nameFont + ' - ' + column.label,
            column.alias
          );
          if (columDependence.length) {
            columDependence.forEach(cl => {
              mastersC.push(cl);
            });
          }
        } else {
          const col: OptionsColumns = {
            key: column.label,
            value: column.alias,
            masterDependencia: nameFont,
            column: column.label,
            type: column.tipo_campo.nombre
          };
          if (col.type === 'date-time-picker') {
            col.category = column.propiedades['tipo'];
          }
          mastersC.push(col);
        }
      }
    });

    return mastersC;
  }

  /**
   * Carga las dependencias de columnas de un selector
   *
   * @param {ColumnsTableModalSelect[]} columns
   * @param {string} nameFont
   * @param {string} prefix
   * @returns {OptionsColumns[]}
   * @memberof CreationFormComponent
   */
  loadColumnsDependence(
    columns: ColumnsTableModalSelect[],
    nameFont: string,
    prefix: string
  ): OptionsColumns[] {
    const mastersC: Array<OptionsColumns> = [];
    if (columns && columns.length) {
      columns.forEach(column => {
        if (column.key) {
          const col: OptionsColumns = {
            key: column.label,
            value: prefix + '-' + column.key,
            masterDependencia: nameFont,
            column: column.label,
            type: column.type
          };
          if (col.type === 'date-time-picker') {
            col.category = column.category;
          } else if (column.type === 'ngSelect') {
            col.columnsSelectorModal = column.columnsDependence;
            const columDependence = this.loadColumnsDependence(
              column.columnsDependence,
              nameFont + ' - ' + column.label,
              prefix + '-' + column.key
            );
            if (columDependence.length) {
              columDependence.forEach(cl => {
                mastersC.push(cl);
              });
            }
          }
          mastersC.push(col);
        }
      });
    }
    return mastersC;
  }

  /**
   * Define la pregunta de la modal
   *
   * @param {string} type
   * @memberof CreationFormComponent
   */
  action(type: string) {
    this.typeAccion = type;
    switch (this.typeAccion) {
      case 'close':
        if (this.newForm) {
          this.question = '¿Realmente desea cancelar la creacion del nuevo formulario?';
        } else {
          this.question = '¿Realmente desea cancelar la edicion del formulario: ' + this.nameForm + '?';
        }
        break;
      case 'deleteControl':
        this.question = '¿Realmente desea eliminar el control del formulario?';
        break;
    }
    this.confirmAction.open();
  }

  /**
   * Define la accion arealizar despues de la respuesta de la modal
   *
   * @param {boolean} res
   * @memberof CreationFormComponent
   */
  actionComfirmClose(res: boolean) {
    if (res) {
      switch (this.typeAccion) {
        case 'close':
          this.closeForm();
          break;
        case 'deleteControl':
          this.deleteControlSelect();
          break;
      }
    }
    this.typeAccion = '';
    this.question = '';
  }

  /**
   * Emite un evento de cierre del componente de creacion de formulario
   *
   * @memberof CreationFormComponent
   */
  closeForm() {
    delete this.newForm;
    delete this.controlsPalette;
    this.orderControlMax = 1;
    this.close.emit(true);
  }

  /**
   * Abre la modal con el formulario y su informcion para editar el control seleccionado
   *
   * @param {Control} control
   * @param {number} index
   * @param {string} [accion='definir']
   * @memberof CreationFormComponent
   */
  async editControl(control: Control, index: number, accion: string = 'definir') {
    this.typeNewControl = control.tipo_campo;
    this.controlSelect = control;
    this.editControlF = true;
    this.controlEditSelect = control.tipo_campo.nombre;
    this.indexControlSelect = index;
    if (control.id) {
      this.control_id = control.id;
    }
    if (accion !== 'definir') {
      this.modalRef.hide();
      this.tmpFormulariosCondictions = control.validaciones.condiciones;
      this.tmpFormulariosOperations = control.validaciones.operaciones;
      switch (control.tipo_campo.nombre) {
        case 'text':
        case 'password':
          this.controlsEdit = this.cdcfs.getFormText(this.sizesControls, control);
          break;
        case 'number':
          this.controlsEdit = this.cdcfs.getFormNumber(this.sizesControls, control);
          break;
        case 'textarea':
          this.controlsEdit = this.cdcfs.getFormTextArea(this.sizesControls, control);
          break;
        case 'checkbox':
          this.controlsEdit = this.cdcfs.getFormCheck(this.templatesSelects, control);
          break;
        case 'email':
          this.controlsEdit = this.cdcfs.getFormEmail(this.sizesControls, control);
          break;
        case 'date-time-picker':
          this.controlsEdit = this.cdcfs.getFormDate(this.sizesControls, control);
          break;
        case 'ngSelect':
          this.columnsMaster = [];
          this.columnsMasterFilter = [];
          this.typeSourceSelect = control.propiedades.tipo;
          this.typeSelectorSelected = control.propiedades.tipoSelector;
          if (control.propiedades.tipo === 'TablaMaestra') {
            if (control.lista_maestra.length) {
              this.idMasterSelected = control.lista_maestra[0].id;
              this.master = await this.cdcds.getInformacionMasterTable(control.lista_maestra[0].id);
              this.columnsMaster = this.cfus.loadingColumnsViews(this.master.estructura, this.idMasterSelected);
              this.columnsMasterFilter = this.cfus.loadingColumnsViews(
                this.master.estructura,
                this.idMasterSelected,
                true
              );
              this.options['columnsMasterFilter'] = filter(
                this.cfus.loadingColumnsViews(
                  this.master.estructura,
                  this.idMasterSelected,
                  true,
                  false
                ),
                { type: 'ngSelect' }
              );
            } else {
              this.idMasterSelected = -1;
              this.master = null;
              this.columnsMaster = [];
              this.columnsMasterFilter = [];
              this.options['columnsMasterFilter'] = [];
            }
            if (this.options['columnsMasterFilter'] && this.options['columnsMasterFilter'].length) {
              this.options['columnsMasterJurisdiccion'] = Static.copyObjet(this.options['columnsMasterFilter']);
              if (this.options['columnsMasterJurisdiccion'] && this.options['columnsMasterJurisdiccion'].length) {
                this.options['columnsMasterJurisdiccion'].push({
                  key: 'Id',
                  value: 'id',
                  masterDependencia: this.master.nombre,
                  column: 'Id',
                  type: 'number'
                });
              } else {
                this.options['columnsMasterJurisdiccion'] = [];
              }
            } else {
              this.options['columnsMasterJurisdiccion'] = [];
            }
            this.controlsEdit = this.cdcfs.getFormSelect(
              this.sizesControls,
              this.masterTables,
              this.customSerach,
              this.templatesSelects,
              control,
              this.columnsMaster,
              this.options
            );
          } else {
            this.idMasterSelected = -1;
            if (control.propiedades['cargar_tabla']) {
              this.formSelect = control.propiedades['cargar_tabla']['form'];
              this.formularioSelect = control.propiedades['cargar_tabla']['formulario'];
            }
            // No consulta directamente el formulario de ngSelect ya que
            // Como es una tabla dinamica debe consultar el formulario por la forma seleccionada
            // Para posteriormente buscar los campos
            this.getFormulario(control, false);
          }
          break;
        case 'label':
          this.controlsEdit = this.cdcfs.getFormLabel(this.sizesControls, control);
          break;
        case 'coordenadas':
          this.controlsEdit = this.cdcfs.getFormCoordinates(control);
          break;
      }
      if (this.controlsEdit.length) {
        this.openForm = true;
        if (!this.form.estilo['formulario_modificable']) {
          this.controlsEdit.forEach(ce => {
            if (ce.controlType == 'container') {
              if (ce['controls'] && ce['controls'].length) {
                ce['controls'].forEach((c: any, i: string | number) => {
                  if (c.key == 'chCampoModificable') {
                    ce['controls'][i].value = false;
                    ce['controls'][i].hidden = true;
                  }
                });
              }
            }
          })
        } else {
          this.controlsEdit.forEach(ce => {
            if (ce.controlType == 'container') {
              if (ce['controls'] && ce['controls'].length) {
                ce['controls'].forEach((c: any, i: string | number) => {
                  if (c.key == 'chCampoModificable') {
                    ce['controls'][i].hidden = false;
                  }
                });
              }
            }
          })
        }
      } else {
        this.openForm = false;
      }
      this.modalRef = this.modalService.show(
        this.template,
        { class: 'modal-lg-personalized', ignoreBackdropClick: true }
      );
    } else {
      this.modalRef = this.modalService.show(this.templateAccion, { class: 'modal-md' });
    }
  }

  /**
   * Elimina el control seleccionado
   *
   * @private
   * @memberof CreationFormComponent
   */
  private deleteControlSelect() {
    if (this.indexControlSelect !== -1) {
      this.controlsPalette.splice(this.indexControlSelect, 1);
      this.indexControlSelect = -1;

      if (this.controlsPalette.length > 0) {
        this.deActiveSave = false;
      } else {
        this.deActiveSave = true;
      }
      this.reorder();
    }
    this.closeFormControl();
  }

  /**
   * Emite un evento con el formulario creado o modificado
   *
   * @param {boolean} [getForm=false]
   * @returns
   * @memberof CreationFormComponent
   */
  saveNewForm(getForm: boolean = false) {
    let validTable = true;
    let typeControl = '';
    if (this.typeTable) {
      for (const control of this.controlsPalette) {
        if (control.tipo_campo.nombre === 'ngSelect') {
          if (
            control.propiedades['tipo'] === 'Condicion' ||
            control.propiedades['tipo'] === 'RadicadosSistema'
          ) {
            validTable = false;
            typeControl = control.propiedades['tipo'];
            break;
          }
        }
      }
    }
    if (
      this.controlsPalette && this.controlsPalette.length &&
      this.nameForm && validTable &&
      this.formAlias.controls['alias'].valid &&
      (
        this.numberRows >= 0 &&
        (
          this.numberRowsMax === 0 ||
          this.numberRowsMax >= this.numberRows
        ) &&
        this.typeTable || !this.typeTable
      ) &&
      (
        this.numberRowsMax >= 0 &&
        (
          this.numberRowsMax === 0 ||
          this.numberRowsMax >= this.numberRows
        ) &&
        this.typeTable ||
        !this.typeTable
      )
    ) {
      this.deActiveSave = true;
      this.purgeControlsPalete();
      if (this.addForm) {
        this.newForm.estilo['formulario_modificable'] = this.modifiable_form;
        this.newForm.campos = this.controlsPalette;
        this.newForm.estilo['auto_saved'] = this.autoSave;
        if (!getForm) {
          this.saveForm.emit(this.newForm);
        } else {
          return this.newForm;
        }
      } else {
        this.form.estilo['formulario_modificable'] = this.modifiable_form;
        this.form.campos = this.controlsPalette;
        this.form.estilo['auto_saved'] = this.autoSave;
        if (!getForm) {
          this.updateForm.emit(this.form);
        } else {
          return this.form;
        }
      }
      delete this.newForm;
      delete this.form;
      delete this.controlsPalette;
      this.orderControlMax = 1;
    } else {
      if (!this.nameForm) {
        this.toastr.warning('Ingrese el nombre del formulario', 'Información incompleta');
      } else if (!this.formAlias.controls['alias'].valid) {
        this.toastr.warning('El alias del formulario es obligatorio, solo permite letras y guiones bajos',
          'Información incompleta');
      } else if ((!this.numberRows && this.numberRows !== 0) && this.typeTable) {
        this.toastr.warning('Ingrese el número de registros mínimos para la tabla',
          'Información incompleta');
      } else if (this.numberRows < 0 && this.typeTable) {
        this.toastr.warning('El número mínimo de registros en la tabla no puede ser un número negativo.',
          'Información incompleta');
      } else if ((!this.numberRowsMax && this.numberRowsMax !== 0) && this.typeTable) {
        this.toastr.warning('Ingrese el número de registros máximo para la tabla',
          'Información incompleta');
      } else if (this.numberRowsMax < 0 && this.typeTable) {
        this.toastr.warning('El número máximo de registros en la tabla no puede ser un número negativo.',
          'Información incompleta');
      } else if ((this.numberRowsMax < this.numberRows) && this.typeTable) {
        this.toastr.warning('El número de registros máximos no puede ser menor a el numero de registros mínimos',
          'Información incompleta');
      } else if (!this.controlsPalette || !this.controlsPalette.length) {
        this.toastr.warning('La forma debe contar con almenos un campo.',
          'Información incompleta');
      } else if (!validTable) {
        if (
          typeControl === 'RadicadosSistema'
        ) {
          this.toastr.error(
            'Las formas de tipo tabla no pueden contener controles que carguen de radicados del sistema, ' +
            'verifique e intente de nuevo.',
            'Información incorrecta'
          );
        } else {
          this.toastr.error(
            'Las formas de tipo tabla no pueden contener controles que carguen de condiciones de la tarea, ' +
            'verifique e intente de nuevo.',
            'Información incorrecta'
          );
        }
      }
      return false;
    }
  }

  /**
   * Cierra el formulario de creacion
   *
   * @memberof CreationFormComponent
   */
  closeFormCreation() {
    delete this.newForm;
    delete this.form;
    delete this.controlsPalette;
    this.orderControlMax = 1;
  }

  /**
   * Focus out de los campos del nombre, alias y numero de registros (para las tablas) para formulario actual
   * setea este dato el en formulario que se esta creando o modificando
   *
   * @param {*} data
   * @param {('name' | 'alias' | 'number')} [action='name']
   * @memberof CreationFormComponent
   */
  onFocusOut(data: any, action: 'name' | 'alias' | 'min' | 'max' | 'onlyRows' = 'name') {
    switch (action) {
      case 'name':
        this.nameForm = data.target.value.trim();
        if (this.addForm) {
          this.newForm.nombre = this.nameForm;
        } else {
          this.form.nombre = this.nameForm;
        }
        break;
      case 'alias':
        this.aliasFormulario = data.target.value;
        if (this.addForm) {
          this.newForm.alias = this.aliasFormulario;
        } else {
          this.form.alias = this.aliasFormulario;
        }
        const form = find(this.formPrincipal.sub_formas, { alias: this.aliasFormulario });
        if (!form) {
          if (!this.formPrincipal.sub_formas) {
            this.formPrincipal.sub_formas = [];
          }
          const subForm = Static.copyObjet(this.newForm);
          this.formPrincipal.sub_formas.push(subForm);
        }
        break;
      case 'min':
        this.numberRows = Number(data.target.value);
        if (this.addForm) {
          this.newForm.numero_registros = this.numberRows;
        } else {
          this.form.numero_registros = this.numberRows;
        }
        break;
      case 'max':
        this.numberRowsMax = Number(data.target.value);
        if (this.addForm) {
          this.newForm.estilo['numero_registros_maximos'] = this.numberRowsMax;
        } else {
          this.form.estilo['numero_registros_maximos'] = this.numberRowsMax;
        }
        break;
      case 'onlyRows':
        this.onlyRows = Boolean(data.target.checked);
        if (this.addForm) {
          this.newForm.estilo['registro_unico'] = this.onlyRows;
        } else {
          this.form.estilo['registro_unico'] = this.onlyRows;
        }
        break;
    }
  }

  /**
   * Reordena el orden de los controles en el formulario
   *
   * @memberof CreationFormComponent
   */
  reorder() {
    if (this.controlsPalette) {
      for (let indexF = 0; indexF < this.controlsPalette.length; indexF++) {
        this.controlsPalette[indexF].orden = indexF + 1;
      }
    }
  }

  /**
   * Controla el cambio de seleccion en el combo de definir el tipo de formulario
   * y guarda este campo
   *
   * @param {*} data
   * @memberof CreationFormComponent
   */
  typeFormSelect(data: any) {
    switch (data.target.value) {
      case 'formulario':
        this.typeTable = false;
        this.numberRows = 0;
        if (this.addForm) {
          this.newForm.numero_registros = this.numberRows;
          if (this.newForm.estilo.hasOwnProperty('fuente')) {
            delete this.newForm.estilo['fuente'];
          }
        } else {
          this.form.numero_registros = this.numberRows;
          if (this.form.estilo.hasOwnProperty('fuente')) {
            delete this.form.estilo['fuente'];
          }
        }
        break;
      case 'tabla':
        this.typeTable = true;
        break;
    }
    this.cdcfs.table = this.typeTable;
    this.autoSave = false;
    if (this.addForm) {
      this.newForm.tabla = this.typeTable;
      if (this.typeTable) {
        this.newForm.estilo['agregar'] = false;
        this.newForm.estilo['modificar'] = false;
        this.newForm.estilo['eliminar'] = false;
      } else {
        delete this.newForm.estilo['agregar'];
        delete this.newForm.estilo['modificar'];
        delete this.newForm.estilo['eliminar'];
      }
    } else {
      this.form.tabla = this.typeTable;
      if (this.typeTable) {
        this.form.estilo['agregar'] = false;
        this.form.estilo['modificar'] = false;
        this.form.estilo['eliminar'] = false;
      } else {
        delete this.form.estilo['agregar'];
        delete this.form.estilo['modificar'];
        delete this.form.estilo['eliminar'];
      }
    }
  }

  /**
   * Retorna el ultimo index de los controles del formulario
   *
   * @private
   * @returns {number}
   * @memberof CreationFormComponent
   */
  private getIndexMaxForm(): number {
    let orderMax = 0;
    this.form.campos.forEach(f => {
      if (f.orden > orderMax) {
        orderMax = f.orden;
      }
    });
    return orderMax + 1;
  }

  /**
   * Detecta el cambio para los ngSelects en la seleccion de la carga de fuente y sus distintas selecciones
   * de tablas dinamicas o tablas maestras cargando las respectivas columnas, formularios o campos
   * @param {*} data
   * @memberof CreationFormComponent
   */
  async changeForm(data: any, refres: boolean = false) {
    if (data.change) {
      // Se valida el tipo de campo para que estos cambios no se vean afectados en los diferentes formularios
      if (this.typeNewControl.nombre === 'ngSelect') {
        // Se crea un nuevo control para guardar temporalmente la informacion ya ingresada en el formulario
        data.change.cboColumn = [];
        const newControl: Control = {
          nombre_campo: null,
          tipo_campo: this.typeNewControl,
          label: data.change.txtLabel,
          espacio: data.change.cboEspacios,
          requerido: data.change.chRequiered ? data.change.chRequiered : false,
          placeholder: data.change.txtPlaceholder,
          tooltip: data.change.txtTooltip,
          dato_radicacion: data.change.txtRadicacion, // Toma el dato de radicación cuando hay cambio en el form
          tipos_documentales_selector: this.typeDocumentaryList,
          orden: 0,
          validaciones: {
            condiciones: [],
            operaciones: [],
            filtros: [],
            condiciones_columnas: []
          },
          estilos: [],
          propiedades: {
            bloquear: data.change.chBloquear,
            tipo: data.change.cboTipoCarga,
            redonly: data.change.chReadOnly,
            columnas_seleccionadas: data.change.selectColumn,
            cargar_tabla: {
              form: data.change.cboForm,
              formulario: data.change.cboFormulario,
              column: data.change.cboColumn
            },
            condicion: data.change.txtAliasCondicion,
            mostrarTabla: this.typeTable ? data.change.chMostrarEnTabla : false,
            modificar_tabla: this.typeTable ? data.change.chModificarEnTabla : false,
            sin_filtro: this.typeTable ? data.chSinFiltro : false,
            tipoSelector: data.change.cboTipoSelect,
            accionesInModal: {
              agregarInModal: data.change.chAgregar ? data.change.chAgregar : false,
              modificarInModal: data.change.chModificar ? data.change.chModificar : false,
              eliminarInModal: data.change.chEliminar ? data.change.chEliminar : false,
            },
            default: data.change.cboDefault,
            validar_sede: data.change.chValidarSede ? data.change.chValidarSede : false,
            tamano_columna: data.change.txtTamanoColumna ? data.change.txtTamanoColumna : null,
            campo_interno: data.change.chInterno ? data.change.chInterno : false,
            columna_general: data.change.chCampoGeneral ? data.change.chCampoGeneral : false,
            consultaAvanzada: data.change.chConsultaAvanzada ? data.change.chConsultaAvanzada : false,
            consultaAvanzadaId: data.change.cboListaAvanzada ? data.change.cboListaAvanzada : null,
            campo_selector_dinamico: data.change.chDynamicSelector ? data.change.chDynamicSelector : false,
            selector_dinamico: data.change.cboDynamicSelector ? data.change.cboDynamicSelector : null,
            asociarProcedimientoFinaizar: data.chAsociarProcedimientoFinalizacion ? data.chAsociarProcedimientoFinalizacion : false
          },
          lista_maestra: [],
          alias: data.change.txtAlias,
          sincronizado: data.change.chSincronizar,
        };

        newControl.propiedades['auto_ajustar_tamano'] = data.change.chAutoAjustar ? data.change.chAutoAjustar : false;

        if (data.change.selectColumnValid) {
          newControl.propiedades['columna_validar_sede'] = data.change.selectColumnValid;
        }
        if (data.change.chGuardarMunicipio) {
          newControl.propiedades['guardar_municipio'] = data.change.selectColumnMunicipality;
        }
        this.typeSelectorSelected = data.change['cboTipoSelect'];
        // Se valida si el tipo de carga de fuente seleccionada es diferente a la anterior
        // Para reiniciar las opciones de los selects
        if (data.change['cboTipoCarga'] !== this.typeSourceSelect || refres) {
          this.typeSourceSelect = data.change['cboTipoCarga'];
          this.formularioSelect = '';
          this.formSelect = '';
          delete this.options['formularios'];
          delete this.options['colums'];
          delete this.options['columnsMasterFilter'];
          this.formularios = [];
          this.fields = [];
          this.idMasterSelected = -1;
          this.columnsMaster = [];
          this.columnsMasterFilter = [];
          if (refres) {
            this.refresListMaster = true;
            newControl.propiedades['columnas_seleccionadas'] = [];
            if (data.change.selectColumnValid) {
              newControl.propiedades['columna_validar_sede'] = null;
            }
            if (this.typeSourceSelect !== 'TablaMaestra') {
              if (!newControl.propiedades['validar_sede']) {
                newControl.propiedades['validar_sede'] = false;
              }
            }
            this.cdcds.getMasterTables().subscribe(mt => {
              this.masterTables = mt;
              this.refreshForm(newControl);
              this.refresListMaster = false;
            });
          } else {
            this.refreshForm(newControl);
          }
        } else if (data.change['cboMasterTable']) {
          // Se valida en que campo se realizo el cambio y se ejecuta las acciones pertinentes
          // Para cargar las opciones de los otros selects
          if (Number(data.change['cboMasterTable']) !== this.idMasterSelected) {
            this.formularioSelect = '';
            this.formSelect = '';
            delete this.options['formularios'];
            delete this.options['colums'];
            this.formularios = [];
            this.fields = [];
            this.idMasterSelected = Number(data.change['cboMasterTable']);
            this.columnsMaster = [];
            this.columnsMasterFilter = [];
            if (data.change.selectColumnValid) {
              newControl.propiedades['columna_validar_sede'] = null;
            }
            this.master = await this.cdcds.getInformacionMasterTable(this.idMasterSelected);
            this.columnsMaster = this.cfus.loadingColumnsViews(this.master.estructura, this.idMasterSelected);
            this.columnsMasterFilter = this.cfus.loadingColumnsViews(
              this.master.estructura,
              this.idMasterSelected,
              true
            );
            this.options['columnsMasterFilter'] = filter(
              this.cfus.loadingColumnsViews(
                this.master.estructura,
                this.idMasterSelected,
                true,
                false
              ),
              { type: 'ngSelect' }
            );
            if (this.options['columnsMasterFilter'] && this.options['columnsMasterFilter'].length) {
              this.options['columnsMasterJurisdiccion'] = Static.copyObjet(this.options['columnsMasterFilter']);
              if (this.options['columnsMasterJurisdiccion'] && this.options['columnsMasterJurisdiccion'].length) {
                this.options['columnsMasterJurisdiccion'].push({
                  key: 'Id',
                  value: 'id',
                  masterDependencia: this.master.nombre,
                  column: 'Id',
                  type: 'number'
                });
              } else {
                this.options['columnsMasterJurisdiccion'] = [];
              }
            } else {
              this.options['columnsMasterJurisdiccion'] = [];
            }
            newControl.lista_maestra = [this.master];
            this.refreshForm(newControl);
          }
        } else if (data.change['cboForm'] && data.change['cboForm'] !== this.formSelect) {
          this.formSelect = data.change['cboForm'];
          this.idMasterSelected = -1;
          this.columnsMaster = [];
          this.columnsMasterFilter = [];
          newControl.propiedades['cargar_tabla'] = {
            form: data.change['cboForm']
          };
          this.formularioSelect = '';
          delete this.options['colums'];
          delete this.options['columnsMasterFilter'];
          this.fields = [];
          this.getFormulario(newControl);
        } else if (data.change['cboFormulario'] && data.change['cboFormulario'] !== this.formularioSelect) {
          this.formularioSelect = data.change['cboFormulario'];
          newControl.propiedades['cargar_tabla'] = {
            form: this.formSelect,
            formulario: this.formularioSelect
          };
          this.getColumns(newControl);
        }
      }
    }
  }

  /**
   * Consulta los formularios de la forma seleccionada para las opciones del  campo de seleccion de forma
   * Acumula los formularios para proximos llamados a la misma forma
   *
   * @param {(Control | any)} newControl
   * @param {boolean} [update=true]
   * @param {boolean} [fountDataTable=false]
   * @memberof CreationFormComponent
   */
  getFormulario(newControl: Control | any, update: boolean = true) {
    this.formularios = [];
    const association = find(this.formPrincipal.asociaciones, { aliasAsociacion: this.formSelect });
    if (this.formPrincipal.alias === this.formSelect) {
      this.formPrincipal.sub_formas.forEach(subForm => {
        if (subForm.tabla && (this.newForm || subForm.alias !== this.form.alias)) {
          if (subForm.alias) {
            this.formularios.push({
              key: subForm.alias,
              value: subForm.nombre,
            });
          }
        }
      });
      this.options['formularios'] = this.formularios;
      if (update) {
        this.refreshForm(newControl);
      } else {
        this.getColumns(newControl);
      }
    } else if (association) {
      const formSeleted: Forma = this.acumulateForm[this.formSelect];
      if (!formSeleted) {
        this.vfcds.getForm(association.idForma).subscribe(form => {
          this.acumulateForm[this.formSelect] = form;
          form.sub_formas.forEach(subForm => {
            if (subForm.tabla) {
              if (subForm.alias) {
                this.formularios.push({
                  key: subForm.alias,
                  value: subForm.nombre,
                });
              }
            }
          });
          this.options['formularios'] = this.formularios;
          if (update) {
            this.refreshForm(newControl);
          } else {
            this.getColumns(newControl);
          }
        });
      } else {
        formSeleted.sub_formas.forEach(subForm => {
          if (subForm.tabla) {
            if (subForm.alias) {
              this.formularios.push({
                key: subForm.alias,
                value: subForm.nombre,
              });
            }
          }
        });
        this.options['formularios'] = this.formularios;
        if (update) {
          this.refreshForm(newControl);
        } else {
          this.getColumns(newControl);
        }
      }
    } else {
      this.options['formularios'] = this.formularios;
      if (update) {
        this.refreshForm(newControl);
      } else {
        this.getColumns(newControl);
      }
    }
  }

  /**
   * Consulta las columnas de el formulario seleccionado para las opciones de la seleccion de columnas
   *
   * @param {Control} newControl
   * @memberof CreationFormComponent
   */
  getColumns(newControl: Control) {
    this.fields = [];
    if (this.formPrincipal.alias === this.formSelect) {
      const subForm = find(this.formPrincipal.sub_formas, { alias: this.formularioSelect });
      if (subForm) {
        if (subForm.tabla) {
          this.fields = this.loadingColumnsTablaForma(subForm.campos, subForm.nombre);
          this.fieldsFilter = this.loadingColumnsTablaForma(subForm.campos, subForm.nombre, false);
        }
      }
    } else {
      const formSeleted: Forma = this.acumulateForm[this.formSelect];
      if (formSeleted) {
        formSeleted.sub_formas.forEach(subForm => {
          if (subForm.tabla && subForm.alias === this.formularioSelect) {
            this.fields = this.loadingColumnsTablaForma(subForm.campos, subForm.nombre);
            this.fieldsFilter = this.loadingColumnsTablaForma(subForm.campos, subForm.nombre, false);
          }
        });
      }
    }
    this.options['columns'] = this.fields;
    this.options['columns_filter'] = this.fieldsFilter;
    this.refreshForm(newControl);
  }

  /**
   * Se encarga de refrescar el formulario de creacion o edicion de control en caso de ser necesario
   *
   * @param {Control} newControl
   * @memberof CreationFormComponent
   */
  refreshForm(newControl: Control) {
    if (this.editControlF) {
      if (this.typeNewControl.nombre === 'ngSelect') {
        if (newControl.propiedades.tipo === 'Tramites') {
          this.options['dynamic_selectors'] = [];
          this.cdcds.getDynamicSelectorFields().subscribe(tsfs => {
            if (tsfs.length > 0) {
              tsfs.forEach(async tsf => {
                await this.options['dynamic_selectors'].push({
                  key: tsf.id,
                  value: tsf.nombre
                });
              });
              this.controls = this.cdcfs.getFormSelect(
                this.sizesControls,
                this.masterTables,
                this.customSerach,
                this.templatesSelects,
                null,
                null,
                this.options
              );
            }
          });



          this.options['columns'] = [];
          this.cdcds.getTramitFields().subscribe(tsfs => {
            if (tsfs.length > 0) {
              tsfs.forEach(tsf => {
                this.options['columns'].push({
                  column: tsf.nombre,
                  key: tsf.nombre,
                  masterDependencia: tsf.alias,
                  type: 'ngSelect',
                  value: tsf.id
                });
              });
              newControl.nombre_campo = this.controlSelect.nombre_campo;
              this.controlsEdit = this.cdcfs.getFormSelect(
                this.sizesControls,
                this.masterTables,
                this.customSerach,
                this.templatesSelects,
                newControl,
                this.columnsMaster,
                this.options
              );
            }
          });
        }
        newControl.nombre_campo = this.controlSelect.nombre_campo;
        this.controlsEdit = this.cdcfs.getFormSelect(
          this.sizesControls,
          this.masterTables,
          this.customSerach,
          this.templatesSelects,
          newControl,
          this.columnsMaster,
          this.options
        );
      }
    } else {
      if (this.typeNewControl.nombre === 'ngSelect') {
        this.controls = this.cdcfs.getFormSelect(
          this.sizesControls,
          this.masterTables,
          this.customSerach,
          this.templatesSelects,
          newControl,
          this.columnsMaster,
          this.options
        );
      }
    }
  }

  /**
   * Abre la modal del formulario de creacion de control
   *
   * @memberof CreationFormComponent
   */
  openFormCreateControl() {
    this.modalRef = this.modalService.show(
      this.templateFormCreate,
      { class: 'modal-lg-personalized', ignoreBackdropClick: true }
    );
    this.openFormControl = true;
  }

  /**
   * Guada las condiciones agregadas al control
   *
   * @param {Array<CondicionControl>} condictions
   * @memberof CreationFormComponent
   */
  savedCondictions(condictions: Array<CondicionControl>) {
    this.tmpFormulariosCondictions = condictions;
  }

  /**
   * Guarda las operaciones agregadas al control
   *
   * @param {Array<OperacionesControl>} operations
   * @memberof CreationFormComponent
   */
  savedOpertions(operations: Array<OperacionesControl>) {
    this.tmpFormulariosOperations = operations;
  }

  /**
   * Guarda los filtros agregadas al control
   *
   * @param {Array<FiltrosSelectores>} filters
   * @memberof CreationFormComponent
   */
  savedFilters(filters: Array<FiltrosSelectores>) {
    this.tmpFormulariosFilters = filters;
  }

  /**
   * Guarda las condiciones de columnas agregadas
   *
   * @param {Array<FiltrosSelectores>} filters
   * @memberof CreationFormComponent
   */
  savedCondictionsColumns(filters: Array<CondicionColumnaSelector>) {
    this.tmpCondictionsColumns = filters;
  }

  /**
   * Guarda las configuraciones agrgadas al control de los accesos a las maestras
   *
   * @param {Array<AccesoMaestra>} configurations
   * @memberof CreationFormComponent
   */
  savedMasterAccessControl(configurations: Array<AccesoMaestra>) {
    this.tmpMasterAccessControl = configurations;
  }

  /**
   * Guarda los documentos seleccionados para la lista de radicados
   *
   * @param {Array<AccesoMaestra>} configurations
   * @memberof CreationFormComponent
   */
  savedRadicationsDocuments(configurations: number[]) {
    this.tmpRadicationsDocuments = configurations;
  }

  /**
   * Guarda los trámites seleccionados
   *
   * @param {number[]} procedures
   * @memberof CreationFormComponent
   */
  savedProcedures(procedures: number[]) {
    this.tmpProcedures = procedures;
  }

  /**
   * Guarda los filtros seleccionados de los trámites
   *
   * @param {number[]} filterProcedures
   * @memberof CreationFormComponent
   */
  savedFilterProcedures(filterProcedures: number[]) {
    this.tmpFilterProcedures = filterProcedures;
  }

  /**
   *Actualiza las condiciones de selector de tipo Número
   *
   * @param {*} data
   * @memberof CreationFormComponent
   */
  updateComparisonCondictions(data: any[]) {
    this.comparisonCondictions = data;
  }

  /**
   *Guarda los tipos documentales seleccionados
   *
   * @param {any[]} data
   * @memberof CreationFormComponent
   */
  savedTypeDocumentary(data: number[]) {
    this.typeDocumentaryList = data;
  }

  stopDocumentarySearching(data: boolean) {
    this.searchDocumentary = data;
  }

  /**
   * Guarda las configuraciones de valores por defecto para la maestra del selector
   *
   * @param {ValoresMaestraPorDefectoSeletor[]} defaultValues
   * @memberof CreationFormComponent
   */
  savedDefaultValuesMaster(defaultValues: ValoresMaestraPorDefectoSeletor[]) {
    this.tmpDefaultValuesMaster = defaultValues;
  }

  /**
   * Abre el modal de opciones espciales para las tablas
   *
   * @memberof CreationFormComponent
   */
  openModalSpecialOptions() {
    this.modalRefSpecialOptions = this.modalService.show(
      this.templateSpecialOptions,
      { class: 'modal-lg-personalized' }
    );
  }

  /**
   * Cierra el modal de opciones especiales para las tablas
   *
   * @memberof CreationFormComponent
   */
  closeModalSpecialOptions() {
    this.modalRefSpecialOptions.hide();
  }

  /**
   * Abre el formulario de creacion de fuente de datos
   *
   * @memberof CreationFormComponent
   */
  openFountDataTable() {
    this.modalRef = this.modalService.show(
      this.templateFountDataTable,
      { class: 'modal-lg-personalized', ignoreBackdropClick: true }
    );
  }

  /**
   * Cierra la modal de creacion o edicion del formulario de fuente de datos
   *
   * @memberof CreationFormComponent
   */
  closeModalFountDataTable() {
    this.formSelect = '';
    this.options = {
      forms: this.allForms
    };
    this.refreshGroupCheckbox();
    this.modalRef.hide();
  }

  /**
   * Abrir modal de grupos de checkbox
   *
   * @param {boolean} [openFormControl=false]
   * @memberof CreationFormComponent
   */
  openModal(openFormControl: boolean = false) {
    if (openFormControl) {
      this.modalRefGrupoCheckbox = this.modalService.show(
        this.templateGroupCheckbox,
        {
          class: 'modal-lg',
          backdrop: 'static'
        }
      );
    } else {
      this.modalRefGrupoCheckbox = this.modalService.show(this.templateGroupCheckbox, { class: 'modal-lg' });
    }
  }

  openDocuments() {
    this.modalRef = this.modalService.show(this.templateSpecial, { class: 'modal-lg-personalized' });
  }

  /**
   * Cierre de modal de grupos de checkbox
   *
   * @memberof CreationFormComponent
   */
  closeModal() {
    this.modalRefGrupoCheckbox.hide();
    this.refreshGroupCheckbox();
  }

  /**
   *Cierra la modal de documentos
   *
   * @memberof CreationFormComponent
   */
  closeDocument() {
    this.modalRef.hide();
  }

  /**
   * Valida si un control tiene la propiedad de modificar en tabla
   *
   * @private
   * @memberof CreationFormComponent
   */
  controlUpdateTable() {
    let valid = false;
    if (this.controlsPalette && this.controlsPalette.length) {
      for (const control of this.controlsPalette) {
        if (control.propiedades['modificar_tabla']) {
          valid = true;
          break;
        }
      }
    }
    return valid;
  }

  /**
   * Refresca las opciones del selector de grupos de checkbox
   *
   * @private
   * @memberof CreationFormComponent
   */
  private refreshGroupCheckbox() {
    const groupCheckbox: Option[] = [];
    if (this.addForm) {
      if (
        this.newForm &&
        this.newForm.estilo &&
        this.newForm.estilo['groupCheckbox'] &&
        this.newForm.estilo['groupCheckbox'].length
      ) {
        this.newForm.estilo['groupCheckbox'].forEach((group: any) => {
          groupCheckbox.push({
            key: group['nombre'],
            value: group['nombre'],
          });
        });
      }
    } else {
      if (
        this.form &&
        this.form.estilo &&
        this.form.estilo['groupCheckbox'] &&
        this.form.estilo['groupCheckbox'].length
      ) {
        this.form.estilo['groupCheckbox'].forEach((group: any) => {
          groupCheckbox.push({
            key: group['nombre'],
            value: group['nombre'],
          });
        });
      }
    }
    this.options['groupCheckbox'] = groupCheckbox;
  }

  /**
   * Elimina las claves innecesarias en el array de controles
   *
   * @private
   * @memberof CreationFormComponent
   */
  private purgeControlsPalete() {
    if (this.controlsPalette && this.controlsPalette.length) {
      this.controlsPalette.map(control => {
        if (!this.typeTable) {
          delete control.propiedades['mostrarTabla'];
          delete control.propiedades['modificar_tabla'];
          delete control.propiedades['activar_modificar'];
          delete control.propiedades['sin_filtro'];
        } else {
          if (control.propiedades['mostrarTabla'] === undefined) {
            control.propiedades['mostrarTabla'] = false;
          }
          if (control.propiedades['modificar_tabla'] === undefined) {
            control.propiedades['modificar_tabla'] = false;
          }
          if (control.propiedades['activar_modificar'] === undefined) {
            control.propiedades['activar_modificar'] = false;
          }
          if (control.propiedades['sin_filtro'] === undefined) {
            control.propiedades['sin_filtro'] = false;
          }
        }
      });
    }
  }

  /**
   * Activa o desactiva la funcion de formulario en modal de la tabla dinamica
   *
   * @memberof CreationFormComponent
   */
  formModal() {
    if (this.addForm) {
      this.newForm.estilo['formulario_modal'] = !this.newForm.estilo['formulario_modal'];
    } else {
      this.form.estilo['formulario_modal'] = !this.form.estilo['formulario_modal'];
    }
  }

  /**
   * Activa o desactiva la funcion de limpiar poir condicion de los formularios
   *
   * @memberof CreationFormComponent
   */
  clearCondiction() {
    if (this.addForm) {
      this.newForm.estilo['limpiar_condicion'] = !this.newForm.estilo['limpiar_condicion'];
    } else {
      this.form.estilo['limpiar_condicion'] = !this.form.estilo['limpiar_condicion'];
    }
  }

  /**
   * Controla la accion de agregar o quitar funciones a la tabla
   *
   * @param {('add' | 'update' | 'delete')} [functionT='add']
   * @memberof CreationFormComponent
   */
  functionTable(functionT: 'add' | 'update' | 'delete' | 'active_update' = 'add') {
    switch (functionT) {
      case 'update':
        if (this.addForm) {
          this.newForm.estilo['modificar'] = !this.newForm.estilo['modificar'];
        } else {
          this.form.estilo['modificar'] = !this.form.estilo['modificar'];
        }
        break;
      case 'delete':
        if (this.addForm) {
          this.newForm.estilo['eliminar'] = !this.newForm.estilo['eliminar'];
        } else {
          this.form.estilo['eliminar'] = !this.form.estilo['eliminar'];
        }
        break;
      case 'active_update':
        if (this.addForm) {
          this.newForm.estilo['activar_modificar'] = !this.newForm.estilo['activar_modificar'];
        } else {
          this.form.estilo['activar_modificar'] = !this.form.estilo['activar_modificar'];
        }
        break;
      default:
        if (this.addForm) {
          this.newForm.estilo['agregar'] = !this.newForm.estilo['agregar'];
        } else {
          this.form.estilo['agregar'] = !this.form.estilo['agregar'];
        }
        break;
    }
  }

  /**
   * Controla el cick del icono de refrescar lista de maestras
   *
   * @param {*} data
   * @memberof CreationFormComponent
   */
  refreshListMasterChangeForm(data: any) {
    if (!this.refresListMaster) {
      this.changeForm(data, true);
    }
  }

  /**
   * Realiza las pertinentes validaciones a un control que se desea guardar en el formulario
   *
   * @private
   * @param {*} data
   * @param {string} action
   * @returns {boolean}
   * @memberof CreationFormComponent
   */
  private validControl(data: any, action: string): boolean {
    let duplicateAlias = false;
    let duplicateControlRadicationSystem = false;
    const alias = find(this.controlsPalette, { alias: data.txtAlias });
    if (alias) {
      if (action === 'agregar') {
        duplicateAlias = true;
      } else {
        if (alias.nombre_campo === this.controlsPalette[this.indexControlSelect].nombre_campo) {
          duplicateAlias = false;
        } else {
          duplicateAlias = true;
        }
      }
    }
    if (data.cboTipoCarga === 'RadicadosSistema') {
      const controlRadicationsSystems = filter(
        this.controlsPalette,
        field => field.tipo_campo.nombre === 'ngSelect' && field.propiedades['tipo'] === 'RadicadosSistema'
      );
      if (controlRadicationsSystems && controlRadicationsSystems.length) {
        if (action === 'agregar') {
          duplicateControlRadicationSystem = true;
        } else {
          if (
            (
              controlRadicationsSystems.length === 1 &&
              controlRadicationsSystems[0].nombre_campo !== this.controlsPalette[this.indexControlSelect].nombre_campo
            ) ||
            controlRadicationsSystems.length > 1
          ) {
            duplicateControlRadicationSystem = true;
          }
        }
      }
    }
    if (duplicateAlias || duplicateControlRadicationSystem) {
      if (duplicateControlRadicationSystem) {
        this.toastr.warning(
          'Para los campos de tipo selector con una fuente de datos de los radicados del sistema, ' +
          'solo puede existir uno en el formulario, verifique e intente de nuevo.',
          'Información incorrecta'
        );
        return false;
      } else {
        this.toastr.warning(
          'El alias ' + alias.alias + ' ya esta siendo utilizado por otro campo en el formulario actual',
          'Duplicación del alias'
        );
        return false;
      }
    }
    return true;
  }

  /**
   *Cancela la modificación del formulario; por lo tanto, la modificación de los campos
   *
   * @param {boolean} event
   * @memberof CreationFormComponent
   */
  cancelModificationForm(event: boolean) {
    if (event) {
      this.modifiable_form = !this.modifiable_form;
      this.form.estilo['formulario_modificable'] = !this.form.estilo['formulario_modificable']
      this.controlsPalette.forEach(cp => {
        if (cp.propiedades.hasOwnProperty('modificar_campo')) {
          cp.propiedades.modificar_campo = false;
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/creation-form.component.ts